import React from "react";

import { SectionTitle } from "@components/SectionTitle";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { PropertiesFilter } from "./PropertiesFilter";
import { PropertiesTable } from "./PropertiesTable";

interface FieldDevicePropertiesProps {
  device: FieldDevice;
}

export const FieldDeviceProperties: React.FC<FieldDevicePropertiesProps> = ({
  device
}) => {
  return (
    <>
      <SectionTitle>Device Properties</SectionTitle>

      <PropertiesFilter>
        {({ values }) => {
          return <PropertiesTable deviceId={device.id} filter={values} />;
        }}
      </PropertiesFilter>
    </>
  );
};
